import radio from './radio.vue'

radio.install = function(Vue) {
  Vue.component(radio.name, radio)
}

export default radio
